const initialState:{[key:string]:any} = {
    newRoleName:"",
    selectedRoleDirectoryOptions: [],
    selectedFeatures:[],
    editMode:false,
    tabValue:'1',
    // allSelectedFeatures:[],
    roleAccessType:'app',
    allRoles: [],
    curRole: ""
};

export function manageRoleReducer(state: any = initialState, action: any){
    const {payload} = action;
    switch(action.type){
        case "setManageRoleState": {
            return {...state,...payload};
        }
        default: {
            return state;
        }
    }
}